import { TreeNode } from 'primeng/api'

export enum ClientIPTreeCategory {
  PROGRAM_ENROLLMENT = 'program-enrollment',
  INDIVIDUAL_PLAN = 'individual-plan',
  GOAL = 'goal',
  STEP = 'step',
}
export type ClientIPTreeCategoryType = ClientIPTreeCategory

export interface ClientIPTreeSimpleData {
  id: number
  programId?: number
  type: ClientIPTreeCategoryType
  programName?: string // Top-level program enrollment name for display in child editors
}

export interface ClientIPTreeData extends ClientIPTreeSimpleData {
  ionIcon: string
  iconTooltip?: string
  importantIcon?: boolean
  displayPlusButton?: boolean
  plusButtonTooltip?: string
  isCompleted?: boolean
  isTerminated?: boolean
  dueDate?: Date
  programName?: string // Top-level program enrollment name for display in child editors
}

export type ClientIPTreeNode = TreeNode<ClientIPTreeData>
